import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentDialogService} from "../../../agents/services/agent-dialogs-service.service";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {$agentFactory} from "../../../agents/$agent.factory";
import {$agentsFactory} from "../../../agents/$agents.factory";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {AgentsService} from "../../../agents/services/agents-service.service";

export class DepotAgentsViewCtrl implements IController {

  depot: any;

  private agentsRef: any;
  private queryString: any;
  private canRemove: any;
  private doReload: any;

  /* @ngInject */
  constructor(private agentDialogService: AgentDialogService, private $state, private bringozLoaderService: BringozLoaderService, private $stateParams,
              private IAMPermissions, private $agent: $agentFactory, private agentsAlerts: AgentsAlerts, private agentsService: AgentsService,
              private $log, private confirmDialogService: ConfirmDialogService, private $agents: $agentsFactory) {

    this.agentsRef = this.$agents();
  }

  $onInit() {
    this.queryString = undefined;
    this.canRemove = this.IAMPermissions.hasPermission('drivers.update');
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onInviteAgent(event) {
    let loading = true;
    this.bringozLoaderService.on();
    this.agentsRef.$getAll({depotIds: [this.depot.id], isActive:true})
      .then((agentIds) => {
        loading = false;
        this.bringozLoaderService.off();
        return this.agentDialogService.addAgents(event, agentIds);
      })
      .then((payload) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.agentsService.addDepots([this.depot.id], payload.ids)
      })
      .then(() => {
        this.doReload = true;
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Failed to invite agent to depot @depotAgentsView@onInviteAgent', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  onCreateAgent(event) {
    this.agentDialogService.createAgent(event, undefined, undefined, this.depot.id)
      .then((createdAgent) => {
        this.$state.go('agent.agent-profile', _.assign({}, this.$stateParams, {id: createdAgent.id, createdAgent: createdAgent}));

      })
  }

  onRemoveAgent(agent, event) {
    this.confirmDialogService.confirm('Remove Driver', 'Are you sure you want to remove this driver from depot?', event)
      .then(() => {
        const agentCopy = angular.copy(agent);
        agentCopy.depotIds = _.without(agent.depotIds, this.depot.id);

        this.bringozLoaderService.on();
        return this.$agent(agent.id).$update(agentCopy);
      })
      .then(() => {
        this.agentsAlerts.removeSuccess(agent);
        this.doReload = true;
      })
      .catch((error) => {
        if (error) {
          this.agentsAlerts.removeError();
          this.$log.info('Failed to remove agent from depot ' +
            '@depotsAgentsView@onRemoveAgent', event);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onReload() {
    this.doReload = undefined;
  }



}

angular
  .module('bringoz.admin.depots')
  .component('depotAgentsView', {
    bindings: {
      depot: '<'
    },
    template: require('./depot-agents-view.html').default,
    controller: DepotAgentsViewCtrl
  });
